/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../banking/common';
import './model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbstatements": {
        "nested": {
          "ListCheckingStatementsRequest": {
            "fields": {
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "skipMissingGeneration": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "filters": {
                "type": ".squareup.bbstatements.CheckingStatementFilter",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "ListCheckingStatementsResponse": {
            "fields": {
              "checkingStatements": {
                "type": ".squareup.bbstatements.CheckingStatement",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "SearchStatementsRequest": {
            "fields": {
              "query": {
                "type": ".squareup.bbstatements.StatementQuery",
                "id": 1,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 20
                }
              },
              "cursor": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "SearchStatementsResponse": {
            "fields": {
              "success": {
                "type": ".squareup.bbstatements.SearchStatementsResponse.Success",
                "id": 1
              },
              "error": {
                "type": ".squareup.bbstatements.SearchStatementsResponse.Error",
                "id": 2
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "ERROR_DO_NOT_USE": 0,
                  "UNAUTHORIZED": 1,
                  "INVALID_QUERY": 2
                }
              },
              "Success": {
                "fields": {
                  "statements": {
                    "type": ".squareup.bbstatements.Statement",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "result": {
                "oneof": ["success", "error"]
              }
            }
          },
          "ExternalBbStatementsService": {
            "methods": {
              "ListCheckingStatements": {
                "requestType": ".squareup.bbstatements.ListCheckingStatementsRequest",
                "responseType": ".squareup.bbstatements.ListCheckingStatementsResponse"
              },
              "SearchStatements": {
                "requestType": ".squareup.bbstatements.SearchStatementsRequest",
                "responseType": ".squareup.bbstatements.SearchStatementsResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbstatements?.nested?.ListCheckingStatementsRequest && !$root.nested?.squareup?.nested?.bbstatements?.nested?.ListCheckingStatementsResponse && !$root.nested?.squareup?.nested?.bbstatements?.nested?.SearchStatementsRequest && !$root.nested?.squareup?.nested?.bbstatements?.nested?.SearchStatementsResponse && !$root.nested?.squareup?.nested?.bbstatements?.nested?.SearchStatementsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bbstatements?.nested?.SearchStatementsResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbstatements?.nested?.ExternalBbStatementsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCheckingStatementsRequest @ squareup/bbstatements/service.proto at 17:1
 */
export const ListCheckingStatementsRequest = $root.lookupType('squareup.bbstatements.ListCheckingStatementsRequest');
fixType(ListCheckingStatementsRequest);
Builder.createAndAttachToType(ListCheckingStatementsRequest);
/**
 * SOURCE ListCheckingStatementsResponse @ squareup/bbstatements/service.proto at 30:1
 */
export const ListCheckingStatementsResponse = $root.lookupType('squareup.bbstatements.ListCheckingStatementsResponse');
fixType(ListCheckingStatementsResponse);
Builder.createAndAttachToType(ListCheckingStatementsResponse);
/**
 * SOURCE SearchStatementsRequest @ squareup/bbstatements/service.proto at 46:1
 */
export const SearchStatementsRequest = $root.lookupType('squareup.bbstatements.SearchStatementsRequest');
fixType(SearchStatementsRequest, {
  query: {
    required: true
  }
});
Builder.createAndAttachToType(SearchStatementsRequest);
/**
 * SOURCE SearchStatementsResponse @ squareup/bbstatements/service.proto at 52:1
 */
export const SearchStatementsResponse = $root.lookupType('squareup.bbstatements.SearchStatementsResponse');
fixType(SearchStatementsResponse);
Builder.createAndAttachToType(SearchStatementsResponse);
/**
 * SOURCE Error @ squareup/bbstatements/service.proto at 53:3
 */
SearchStatementsResponse.Error = $root.lookupEnum('squareup.bbstatements.SearchStatementsResponse.Error').values;
/**
 * SOURCE Success @ squareup/bbstatements/service.proto at 59:3
 */
SearchStatementsResponse.Success = $root.lookupType('squareup.bbstatements.SearchStatementsResponse.Success');
fixType(SearchStatementsResponse.Success);
Builder.createAndAttachToType(SearchStatementsResponse.Success);
/**
 * SOURCE ExternalBbStatementsService @ squareup/bbstatements/service.proto at 87:1
 */
export const ExternalBbStatementsService = $root.lookupService('squareup.bbstatements.ExternalBbStatementsService');